module.exports = __webpack_public_path__ + "static/media/upArrow.d49e2a6f.svg";